import objectsEqual from './objectsEqual';
export default objectsEqual;
